// src/ToastContext.js
import React, { createContext, useContext } from "react";
import toast from "react-hot-toast";

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  return (
    <ToastContext.Provider value={toast}>{children}</ToastContext.Provider>
  );
};

export const useToast = () => {
  return useContext(ToastContext);
};